/**
 * /payroll/pf-ceiling — "PF ceiling change: who's affected" (EPF ceiling
 * ₹25,000 from 17 Sep 2026; docs/superpowers/specs/2026-10-21-epf-ceiling-25k.md).
 *
 * HR-admin (PayrollModuleShell's role gate mirrors the backend's
 * payrollRole). Reached from the payroll-home strip and from a locked run's
 * "Correct PF" line, under the /payroll prefix (Run surface) — not a
 * URL-only orphan.
 */

import { createFileRoute, useParams } from "@tanstack/react-router";
import { PayrollModuleShell } from "@/components/shared/payroll-module-shell";
import { PFCeilingReview } from "@/components/payroll/pf-ceiling-review";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/payroll/pf-ceiling")({
  component: PFCeilingRoute,
});

function PFCeilingRoute() {
  const { tenantSlug } = useParams({ strict: false }) as { tenantSlug: string };
  return (
    <PayrollModuleShell
      title="PF Ceiling Change: Who's Affected"
      description="From 17 Sep 2026 PF is worked out on pay up to ₹25,000 a month (was ₹15,000). September is split: ₹15,000 for 1–16 Sep, ₹25,000 from 17 Sep."
    >
      <PFCeilingReview tenantSlug={tenantSlug} />
    </PayrollModuleShell>
  );
}
